

import React from 'react';

export default function SelectComponent(props) { 
    const register = props?.register;
    
    return (
        <React.Fragment>
                <label htmlFor={props.htmlFor}>{props.label}
                    {
                        props.isStrong ?
                            <strong className="text-primary">*</strong>
                            : null
                    }
                </label>
                    <select className="custom-select" {...register(props.name, props.requiredObj)}>
                        {
                            props.selectOption ? null :
                            <option value="">- Select -</option>
                        }
                        {
                            props?.data.map((item, index)=>(
                                <option value={item.value} key={index}>{item.name}</option>
                            ))
                        }
                    </select>
                    <small id={props.genderHelp} className="text-primary">
                    {props?.errMsg}
                </small>
        </React.Fragment>
    )
}